import { MindYetiPlaylistContainer } from './container'

export default MindYetiPlaylistContainer
